import PropTypes from "prop-types"
import { MenuItem } from "@mui/material"
import { Controller } from "react-hook-form"
import DropdownCommon from "./DropdownCommon"

const DropdownCreneaux = ({ control, disabled, label, multiple, name, options, ...rest }) => {
  const toToken = (value) => String(value).replace(/[^a-zA-Z0-9_-]/g, "-")

  const renderOptions = (options, native) => {
    const optionsList = options.map((option) => {
      if (native) {
        return (
          <option
            data-field={name}
            data-testid={`${name}-option-${toToken(option.value)}`}
            data-value={option.value}
            disabled={option.places <= 0}
            key={option.value}
            value={option.value}
          >
            {option.label}
          </option>
        )
      }

      return (
        <MenuItem
          data-field={name}
          data-testid={`${name}-option-${toToken(option.value)}`}
          data-value={option.value}
          disabled={option.places <= 0}
          key={option.value}
          value={option.value}
        >
          {option.label}
        </MenuItem>
      )
    })

    if (native && !multiple) {
      return [<option key="empty-option" value="" />, ...optionsList]
    }

    return optionsList
  }

  return (
    <Controller
      control={control}
      label={label}
      name={name}
      render={({
        field: { onChange, value },
        fieldState: { error }
      }) => (
        <DropdownCommon
          {...rest}
          error={error}
          label={label}
          name={name}
          onChange={onChange}
          renderOptions={renderOptions(options, !!rest.native)}
          value={value}
        />
      )}
    />
  )
}

DropdownCreneaux.propTypes = {
  control: PropTypes.object.isRequired,
  disabled: PropTypes.bool,
  label: PropTypes.string.isRequired,
  multiple: PropTypes.bool,
  native: PropTypes.bool,
  name: PropTypes.string.isRequired,
  options: PropTypes.array.isRequired
}

export default DropdownCreneaux
